import { Injectable, Provider } from '@angular/core';

import { SpeiAttemptsByNode } from '@app/domain/models/spei/spei-attempts-by-node';
import {
  CARDS_SPEI_ATTEMPTS_CAPACITY,
  CardsSpeiBatchDoubts,
  CardsSpeiBatchKeys,
  CardsSpeiIndividualAttemptKeys,
} from '@app/domain/models/cards/cards-spei-attempt-memory';
import { CardsSpeiAttemptMemory } from '@app/domain/ports/cards/cards-spei-attempt-memory';

/**
 * Los intentos de orden SPEI de Cards, por nodo, en la memoria de la PESTAÑA
 * (feature 124).
 *
 * - Singleton raíz, como `TotpLockService`: sobrevive a salir de la pantalla y
 *   volver (el desenlace desconocido manda a "Pendientes", otra ruta), así que
 *   re-subir el MISMO archivo o reteclear la MISMA orden reusa la llave.
 * - ⚠️ Solo heap: nada va a `sessionStorage`, `localStorage`, la URL ni a logs.
 *   Recargar la pestaña la pierde (aceptado: persistir está prohibido).
 * - Se vacía en `LogoutService.logout()`: el cierre de sesión navega sin recargar
 *   y el siguiente usuario de la pestaña no puede heredar intentos.
 * - Sin caducidad propia (Q5): caducar antes que banca (24 h) reabriría el hueco.
 */
@Injectable({ providedIn: 'root' })
export class InMemoryCardsSpeiAttemptMemory extends CardsSpeiAttemptMemory {
  readonly orders = new SpeiAttemptsByNode<CardsSpeiIndividualAttemptKeys>(CARDS_SPEI_ATTEMPTS_CAPACITY);
  readonly batches = new SpeiAttemptsByNode<CardsSpeiBatchKeys>(CARDS_SPEI_ATTEMPTS_CAPACITY);
  readonly batchDoubts = new CardsSpeiBatchDoubts(CARDS_SPEI_ATTEMPTS_CAPACITY);

  clear(): void {
    this.orders.clear();
    this.batches.clear();
    this.batchDoubts.clear();
  }
}

/**
 * El enlace del puerto con el singleton de la pestaña. Va SOLO en la raíz
 * (`app.config.ts`, y en los TestBed como raíz). ⚠️ Nunca en `providers` de una
 * página ni en `provideCardsSpeiOrders()`.
 */
export function provideCardsSpeiAttemptMemory(): Provider[] {
  return [{ provide: CardsSpeiAttemptMemory, useExisting: InMemoryCardsSpeiAttemptMemory }];
}
